



















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { MenuBaseFields } from "../../NewConfig";

@Component
export default class SidebarTag extends Vue {
    @Prop() tags!: MenuBaseFields['tags']
}
